export default [
  {
    title: "Početna",
    route: "Home",
    icon: "HomeIcon",
    featherIcon: true,
  },
  {
    title: "Uređaji",
    route: "DevicesIndex",
    icon: "RadioIcon",
    featherIcon: true,
  },
  {
    title: "Grla",
    route: "CattleIndex",
    icon: "icon-cow-silhouette",
  },
  // {
  //   title: "Pozicije grla",
  //   route: "TrackingIndex",
  //   icon: "MapPinIcon",
  //   featherIcon: true,
  // },
  {
    title: "Virtuelna ograda",
    route: "VirtualFenceIndex",
    icon: "icon-map-path",
  },
  {
    title: "Podešavanja",
    route: "SettingsIndex",
    icon: "SettingsIcon",
    featherIcon: true,
  },
];
